export const todayStr = () => new Date().toISOString().slice(0, 10);

export const threeMonthsAgoStr = () => {
  const date = new Date();
  date.setMonth(date.getMonth() - 3);
  return date.toISOString().slice(0, 10);
};

export const weekAgoStr = () =>
  new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10);

export const formatLongDate = (dateStr) => {
  if (!dateStr) return "All";
  const d = new Date(`${dateStr}T00:00:00`);
  return d.toLocaleString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
};
